import { Fragment } from "react";
import { cn } from "@/lib/utils";
import {
  parseRichText,
  type RichInline,
} from "@/modules/threads/richTextParser";

const Inline = ({ nodes }: { nodes: RichInline[] }) => (
  <>
    {nodes.map((node, index) => {
      switch (node.type) {
        case "text":
          return <Fragment key={index}>{node.value}</Fragment>;
        case "bold":
          return (
            <strong key={index} className="font-semibold">
              <Inline nodes={node.children} />
            </strong>
          );
        case "italic":
          return (
            <em key={index}>
              <Inline nodes={node.children} />
            </em>
          );
        case "mention":
          return (
            <span key={index} className="font-medium text-primary">
              @{node.name}
            </span>
          );
        case "link":
          return (
            <a
              key={index}
              href={node.href}
              target="_blank"
              rel="noreferrer"
              className="break-all text-primary underline-offset-2 hover:underline"
              onClick={(event) => event.stopPropagation()}
            >
              {node.label}
            </a>
          );
      }
    })}
  </>
);

/** Thread note with bold, italic, links, bullets and highlighted @mentions. */
export const ThreadRichText = ({
  text,
  className,
}: {
  text?: string | null;
  className?: string;
}) => (
  <div className={cn("space-y-1.5 text-sm break-words", className)}>
    {parseRichText(text).map((block, index) =>
      block.type === "list" ? (
        <ul key={index} className="list-disc space-y-0.5 pl-5">
          {block.items.map((item, itemIndex) => (
            <li key={itemIndex}>
              <Inline nodes={item} />
            </li>
          ))}
        </ul>
      ) : (
        <p key={index}>
          {block.lines.map((line, lineIndex) => (
            <Fragment key={lineIndex}>
              {lineIndex > 0 ? <br /> : null}
              <Inline nodes={line} />
            </Fragment>
          ))}
        </p>
      ),
    )}
  </div>
);
